import Dashboard from "../pages/Dashboard";
import Master from "../pages/Master";
import { PROGRAM_CODE, USER_ROLE } from "data/constants";
import auth from "@standard/services/auth";
import Transaction from "pages/Transaction";

export const Menues = [
  {
    label: "Master",
    iconClass: "fa fa-users",
    child: [
      {
        label: "User",
        link: "/master/user",
        component: Master.User,
        code: PROGRAM_CODE.MASTER_USER,
      },
      {
        label: "Customer",
        link: "/master/customer",
        component: Master.Customer,
        code: PROGRAM_CODE.MASTER_CUSTOMER,
      },
      {
        label: "Document Template",
        link: "/master/documenttemplate",
        component: Master.DocumentTemplate,
        code: PROGRAM_CODE.MASTER_DOCUMENT_TEMPLATE,
      },
      {
        label: "Setting",
        link: "/master/setting",
        component: Master.Setting,
        code: PROGRAM_CODE.MASTER_SETTING,
      },
    ],
  },
  {
    label: "Transaction",
    iconClass: "fa fa-users",
    child: [
      {
        label: "Job",
        link: "/transaction/job",
        component: Transaction.Job,
        code: PROGRAM_CODE.TRANSACTION_JOB,
      },
      {
        label: "Job Upload",
        link: "/transaction/jobupload",
        component: Transaction.JobUpload,
        code: PROGRAM_CODE.TRANSACTION_JOB_UPLOAD,
      },
      {
        label: "Job Authen by Manager",
        link: `/transaction/jobauthen/${USER_ROLE.MANAGER}`,
        component: Transaction.JobAuthen,
        code: PROGRAM_CODE.TRANSACTION_JOB_AUTHEN_MANAGER,
      },
      {
        label: "Job Authen by Safety",
        link: `/transaction/jobauthen/${USER_ROLE.SAFETY}`,
        component: Transaction.JobAuthen,
        code: PROGRAM_CODE.TRANSACTION_JOB_AUTHEN_SAFETY,
      },
    ],
  },
];

function getMenuByProfile() {
  const menuProfiles = auth.getMenuProfiles();

  if (menuProfiles)
    return Menues.map((f) => {
      if (f.child) {
        return {
          ...f,
          child: f.child.filter((child) => menuProfiles.includes(child.code)),
        };
      }

      if (menuProfiles.includes(f.code)) return f;

      return null;

      return f;
    }).filter((f) => {
      if (f === null) return false;
      if (f.child === undefined || f.child.length > 0) return true;

      return false;
    });

  return [];
}

export default [
  {
    label: "Dashboard",
    iconClass: "fa fa-dashboard",
    link: "/",
    exact: true,
    component: Dashboard,
  },
  ...getMenuByProfile(),
];
